import styled from 'styled-components';
import { media } from '../../theme';

export const TableWrapper = styled.div`
    margin-top: 8px;
    min-width: 100px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    
    ${media.sm} {
        width: 100%;
    }
`;

export const Table = styled.table`
    display: block;
    width: 100%;
    min-width: 0;
    border-collapse: collapse;
    margin-bottom: 4px;
    border-radius: 20px;
    white-space: normal;

    thead {
        display: none;
    }

    tbody {
        display: grid;
    }

    ${media.sm} {
        display: table;
        white-space: nowrap;

        thead {
            display: table-header-group;
            font-weight: 500;
            font-size: 17px;
        }

        tbody {
            display: table-row-group;
        }
    }
`;

export const TableRow = styled.tr`
    display: block;
    width: clamp(120px, 100%, 360px);
    background-color: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.light};
    border-radius: 12px;
    margin: 12px 0;
    overflow: hidden;

    &:nth-child(even) {
        background-color: transparent;
    }

    transition: background-color 200ms ease;

    &:hover {
        background-color: inherit;
    }

    &.cancelled {
        opacity: 0.45;
        pointer-events: none;
    }
    
    ${media.sm} {
        display: table-row;
        width: auto;
        border: none;
        border-radius: 0;
        margin: 0;
        overflow: visible;

        &:nth-child(even) {
            background-color: ${({theme}) => theme.palette.background.dropzone};
        }

        &:hover {
            background-color: ${({theme}) => theme.palette.action.hoveredDropzone};
        }
    }
`;

export const TableCell = styled.td<{ $sortable?: boolean; $active?: boolean }>`
    padding: 12px 16px;
    border-bottom: 1px solid ${({theme}) => theme.palette.dividers.light};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6px;
    text-align: left;
    word-break: break-word;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    
    .mobile-only {
        display: inline-flex;
        width: 100%;
    }

    .desktop-only {
        display: none;
    }

    &::before {
        content: attr(data-label);
        display: block;
        font-weight: 600;
        font-size: 12px;
        color: #6b778c;
        margin: 0 0 4px 0;
    }

    &.actions-cell {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;

        &::before {
            margin-bottom: 4px;
        }

        button {
            width: 100%;
            justify-content: center;
        }
    }

    ${media.sm} {
        display: table-cell;
        padding: 16px;
        vertical-align: middle;

        .mobile-only {
            display: none;
        }

        .desktop-only {
            display: inline-flex;
        }

        &::before {
            content: none;
            display: none;
        }

        &:last-child:not(:only-child) {
            text-align: center;
            max-width: 245px;
        }

        &.empty-cell {
            text-align: center;
            max-width: none;
        }
        
        &.actions-cell {
            flex-direction: initial;
            align-items: initial;
            gap: 0;

            button {
                width: auto;
            }

            button + button {
                margin-left: 8px;
            }
        }
      
        cursor: ${({ $sortable }) => $sortable ? 'pointer' : 'default'};
        user-select: ${({ $sortable }) => $sortable ? 'none' : 'auto'};
    }
`;

export const SortableHeaderContent = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;